module.exports = __webpack_public_path__ + "img/testroom3.19868f71.png";